module.exports = __webpack_public_path__ + "img/069c2b1.png";